import { render, staticRenderFns } from "./richDetail.vue?vue&type=template&id=f2277a4c&scoped=true&"
import script from "./richDetail.vue?vue&type=script&lang=js&"
export * from "./richDetail.vue?vue&type=script&lang=js&"
import style0 from "./richDetail.vue?vue&type=style&index=0&id=f2277a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2277a4c",
  null
  
)

export default component.exports